import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.community.list');
import { OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-community-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.community.list/view.scss */
/* src/app/portal.community.list/view.scss: no such file or directory */`],
})
export class PortalCommunityListComponent implements OnInit, OnChanges {

    @Input() category: string = 'notice';

    public list: any[] = [];
    public search: any = {};
    public facet: any = { lastpage: 1 };
    public title = '';
    public role: string | null = null;
    public loading: boolean = false;

    constructor(@Inject( Router)         private router: Router,@Inject( Service    )         public service: Service    ) {}

    async ngOnInit() {
        await this.service.init();
        this.role = this.service.auth.session?.role || null;
        await this.apply();
    }

    async ngOnChanges(changes: SimpleChanges) {
        if (changes['category'] && !changes['category'].firstChange) {
            await this.apply();
        }
    }

    private async apply() {
        this.title =
            this.category === 'notice' ? '공지사항' :
            this.category === 'faq' ? '문의사항' :
            '게시판';

        this.search = {
            page: 1,
            text: '',
            category: this.category
        };

        await this.load();
        await this.service.render();
    }

    create() {
        this.router.navigate(['/community', this.category, 'edit', 'new']);
    }

    goView(item: any) {
        this.router.navigate(['/community', this.category, 'view', item.id]);
    }

    
    async load() {
        this.loading = true;
        await this.service.render();

        const res = await wiz.call('search', this.search);
        if (res.code === 200) {
            this.list = res.data.list;
            this.facet.lastpage = res.data.lastpage || 1;
        }

        this.loading = false;
        await this.service.render();
    }

    async goPage(page: number) {
        if (page < 1 || page > this.facet.lastpage) return;
        if (page === this.search.page) return;

        this.search.page = page;
        await this.load();
    }

    public onPageChange = async (page: number) => {
        await this.goPage(page);
    }
    
    async searchSubmit() {
        this.search.page = 1;
        await this.load();
    }
}

export default PortalCommunityListComponent;